// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-small {\n  font-size: 0.8rem;\n}\n.custom-switch .custom-control-input:disabled ~ .custom-control-label {\n  cursor: not-allowed;\n}\n.custom-switch .custom-control-input:disabled:not(:checked) ~ .custom-control-label::before {\n  background-color: #d2ddec !important;\n}\n", ""]);
// Exports
module.exports = exports;
